<template>
  <div>
    <table class="table is-fullwidth">
      <tr v-for="(item, index) in data" v-bind:key="item.id">
        <th v-if="item.length > 0">{{ $t('app.' + index) }}</th>
        <td v-if="item.length > 0 && typeof item == 'string'">{{ item }}</td>
        <td v-if="item.length > 0 && typeof item == 'object'">
          <table>
            <tr v-for="it in item" v-bind:key="it.id">
              <td v-for="td in it.split(';')" v-bind:key="td.id" class="is-size-7">{{ td }}</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      data: []
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=SirketProfil?symbol=" +
          this.symbol +
          "?lang=" +
          this.$i18n.locale,
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then(response => this.initJSON(response));
  },
  filters: {
    titleArr: function(title) {
      let titleArr = {
        KurulusTarihi: "Kuruluş Tarihi",
        SirketAdi: "Şirket Adı",
        Sektor: "Sektör",
        GenelMudur: "Genel Müdür",
        CalisanSayisi: "Çalışan Sayısı",
        listeholders: "Ortaklar",
        listeholdings: "İştirakler",
        YetkiliAd: "Yatırımcı İlişkileri Yetkilisi",
        YetkiliMail: "Mail Adresi"
      };
      let rtitle = titleArr[title];
      if (typeof rtitle == "undefined") {
        rtitle = title;
      }
      return rtitle;
    }
  },
  methods: {
    initJSON: function(response) {
      this.data = JSON.parse(
        iconv.decode(Buffer.from(response.data), "ISO-8859-9")
      );
    }
  }
};
</script>